import { SvgIcon, type SvgIconProps } from '~/@mid_ui/icons/svgIcon'
import { cn } from '~/shadcn/lib/utils'

export function FilterOnIcon({
  width = 24,
  height = 24,
  className,
  ...props
}: SvgIconProps) {
  return (
    <SvgIcon
      width={width}
      height={height}
      viewBox="0 0 24 24"
      className={cn('w-6! h-6!', className)}
      {...props}>
      <path
        d="M10.251 20.7499V12.9647L2.60938 3.25H21.3925L13.7509 12.9647V20.7499H10.251ZM12.001 12.35L17.776 4.99997H6.22595L12.001 12.35Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}
